import { lazy } from "react";

// Lazy load components
const SearchPage = lazy(() => import("./components/DashBoard/DashBoard"));
const ExpenseForm = lazy(() => import("./components/ExpenseForm/ExpenseForm"));
const ChatBox = lazy(() => import("./components/ChatBox/ChatBox"));
const UploadImage = lazy(() => import("./components/UploadImage/UploadImage"));
const RecurringExpenses = lazy(() =>  import("./components/Subscription/RecurringExpenses"));
const RecurringExpenseHistory =lazy(() =>  import("./components/Subscription/RecurringExpenseHistory"));
const MyCardsPage = lazy(() => import("./components/Settings/MyCardsPage"));
const SettingsPage = lazy(() => import("./components/Settings/SettingsPage"));
const Login = lazy(() => import("./components/Login/LoginPage"));
const SignUp = lazy(() => import("./components/SignUp/SignUpPage"));
const FamilyMembersPage = lazy(() => import("./components/Settings/FamilyMembersPage"));
const GroupsListPage = lazy(() => import("./components/Settings/Groups/GroupsListPage"));
const GroupMembersPage = lazy(() => import("./components/Settings/Groups/GroupMembersPage"));
const ReturnItems = lazy(() => import("./components/Settings/ReturnItems"));
const Verification = lazy(() => import("./components/Login/verification"));
const ExpenseDetails = lazy(() => import("./components/ExpenseDetails/ExpenseDetails"));
const Labels = lazy(() => import("./components/Settings/Labels/Labels"));
const GroupMemberExpense= lazy(() => import("./components/Settings/Groups/GroupMemberExpense"));
const RestaurantMenuPage= lazy(() => import("./components/Restaurant/RestaurantMenuPage"));
const SharedExpenses= lazy(() => import("./components/ShareExpense/ShareExpense"));
// Password Reset Components
const ForgotPassword = lazy(() => import("./components/Login/ForgotPassword"));
const ResetPassword = lazy(() => import("./components/Login/ResetPassword"));
const CategoryMapping = lazy(() => import("./components/Settings/CategoryMapping/CategoryMappingPage"));
// Define public routes
export const publicRoutes = [
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/verification", element: <Verification /> },
];

// Define private routes
export const privateRoutes = [
  { path: "/dashboard", element: <SearchPage /> },
  { path: "/expense-form", element: <ExpenseForm /> },
  { path: "/conversational-ai", element: <ChatBox /> },
  { path: "/uploadImage", element: <UploadImage /> },
  { path: "/recurringExpenses", element: <RecurringExpenses /> },
  { path: "/recurringExpenses/history/:expenseId", element: <RecurringExpenseHistory /> },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/myCards", element: <MyCardsPage /> },
  { path: "/returnItems", element: <ReturnItems /> },
  { path: "/family-members", element: <FamilyMembersPage /> },
  { path: "/groupLists", element: <GroupsListPage /> },
  { path: "/groups/:groupId", element: <GroupMembersPage /> },
  { path: "/groupExpenseDetails/:groupId", element: <GroupMemberExpense /> },
  { path: "/expenseDetails", element: <ExpenseDetails /> },
  { path: "/labels", element: <Labels /> },

  { path: "/restaurantMenu", element: <RestaurantMenuPage /> },

  { path: "/restaurantMenu/:tableGuid", element: <RestaurantMenuPage /> },
  
  { path: "/sharedExpenses", element: <SharedExpenses /> },
  { path: "/categoryMapping", element: <CategoryMapping /> },
];
